<template>
  <div class="class">
    <div class="content-wrapper">
      <div class="content">
        <div class="class-head clearfix">
          <!--<button class="add"-->
          <!--v-if="schoolNow.iscreator||schoolNow.ismanager"-->
          <!--@click="showAddTeacher">{{$t('m.class_add_teacher')}}-->
          <!--</button>-->
          <button class="modify" @click="showChangeLesson">{{$t('m.class_modify_course')}}</button>
          <button class="share" @click="showShareLesson">{{$t('m.class_share_course')}}</button>
          <img class="img"
               @click="lessonPreviewShow=true;"
               :src="imgprefix+lessoninfo.faceimg"
               alt="cover"
               width="150"
               height="100">
          <div class="class-info" v-if="lessoninfo">
            <p class="title" @click="lessonPreviewShow=true;">《{{decodeURIComponent(lessoninfo.lessonname)}}》
              <img class="preview" src="./preview.png" alt="preview" width="24" height="24">
              <span class="preview-text">{{$t('m.class_preview')}}</span>
            </p>
            <p class="type" @click="lessonPreviewShow=true;">{{decodeURIComponent(lessoninfo.typename)}}</p>
            <div class="intro">
              <span class="intro-left">{{$t('m.cou_n_course_introduce')}}</span>
              <span class="intro-right">{{cutIntroduce(lessoninfo.introduce)}}
                <span class="more" @click="showChangeLesson">{{$t('m.class_more')}}>></span>
              </span>
            </div>
          </div>
          <button class="demo" @click="QueryRecordCourseWare('outside')">{{$t('m.class_makedemovideo')}}</button>
        </div>
        <div class="middle">
          <button class="new-class" @click="showAddClass">{{$t('m.class_new_class')}}</button>
          <!--<el-radio-group v-model="radioSelect">-->
          <!--<el-radio label="显示全部"></el-radio>-->
          <!--<el-radio label="已开课的班级"></el-radio>-->
          <!--<el-radio label="正在招生的班级"></el-radio>-->
          <!--</el-radio-group>-->
        </div>
        <div class="class-list">
          <div class="class-item" v-for="(item,index) in classList"
               v-if="(index>=(currentPage-1)*6)&&(index<currentPage*6)">
            <div class="flex-wrapper">
              <div class="title-wrapper">
                <h2 class="title">{{decodeURIComponent(item.classmodename)}}-{{decodeURIComponent(item.classname)}}</h2>
                <span class="free-icon" v-if="item.democlass==='1'">{{$t('m.class_free_class')}}</span>
              </div>
              <p class="enroll">{{$t('m.class_enroll')}}{{item.enrollnums}}{{$t('m.class_enroll2')}}</p>
            </div>
            <div class="information-wrapper" @click="gotoClassSchedule(item)">
              <div class="flex-wrapper">
                <div class="left">
                  <p class="time">
                    {{$t('m.class_time')}}{{item.startdate + ' ' + item.starttime.substring(0, 5) + '~' +
                    item.endtime.substring(0, 5)}}</p>

                </div>

              </div>
              <p class="num">
                <template v-if="item.democlass=='1'">试听课时:共一课</template>
                <template v-else>总课时长:{{computeTotalHour(item.classhour)}}</template>
              </p>
            </div>
            <div class="btn-wrapper">
              <button class="open" @click="openLive(item)">{{$t('m.class_openlive')}}</button>
              <template v-if="item.democlass=='1'">
                <button class="on" v-show="item.ispublish==0" @click="whetherGrounding(item.id)">
                  {{$t('m.class_startsell')}}
                </button>
                <button class="off" v-show="item.ispublish==1"
                        @click="offgrounding(item)">{{$t('m.class_stopsell')}}
                </button>
              </template>
              <template v-if="item.democlass=='0'">
                <button class="on" v-show="item.ispublish==0" @click="whetherGrounding(item.id)">
                  {{$t('m.class_startsell')}}
                </button>
                <button class="off" v-show="item.ispublish==1"
                        @click="offgrounding(item)">{{$t('m.class_stopsell')}}
                </button>
              </template>
              <button class="delete" @click="openDelete(item.id)"
                      v-show="item.ispublish==0&&item.enrollnums==0">{{$t('m.class_delete')}}
              </button>
              <button class="modify" v-show="item.ispublish==0"
                      @click="showChangeClass(item)">{{$t('m.class_modify')}}
              </button>
              <!--<button class="share" @click="showShareClass(item)">{{$t('m.class_share')}}</button>-->
              <!--<button class="copy" @click="openCopy(item)" v-show="item.democlass==0">{{$t('m.class_copy')}}</button>-->
            </div>

          </div>
        </div>
        <template v-if="!isEmpty(classList)">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="6"
            :total="totoalPage">
          </el-pagination>
        </template>
      </div>
    </div>
    <top-nav :list="topList"></top-nav>
    <!--<above-nav></above-nav>-->
    <!--点击课程预览按钮-->
    <div class="classpop-mask" v-if="lessonPreviewShow">
      <div class="classpop">
        <h2 class="title">
          {{$t('m.class_pre_sectionTitle')}}
          <img class="close" @click="lessonPreviewShow=false" src="./close.png" alt="close" width="20" height="20">
        </h2>
        <p class="row">
          <span class="left">{{$t('m.cou_n_course_title')}}</span>
          <span class="text">《{{decodeURIComponent(lessoninfo.lessonname)}}》</span>
        </p>
        <p class="row">
          <span class="left">{{$t('m.cou_n_course_type')}}</span>
          <span class="text">{{decodeURIComponent(lessoninfo.typename)}}</span>
        </p>
        <div class="cover-row">
          <span class="left">{{$t('m.cou_n_course_cover')}}</span>
          <span class="right">
            <span class="img-wrapper">
              <img class="img" :src="imgprefix+lessoninfo.faceimg" alt="cover" width="150" height="100">
            </span>
          </span>
        </div>
        <div class="introduce-wrapper" v-if="!isEmpty(computeLessonIntroduceList(lessoninfo.introduce))">
          <div class="split"></div>
          <div class="left">{{$t('m.cou_n_course_introduce')}}</div>
          <div class="introduce">
            <template v-for="(item,index) in computeLessonIntroduceList(lessoninfo.introduce)">
              <pre class="text" v-if="item.isImage==false&&item.text!==''">{{item.text}}</pre>
              <div class="image" v-if="item.isImage==true&&item.width!==0">
                <img :src="imgprefix+item.image" alt="img" width="260">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!--修改课程弹出框,之所以class是classpop-mask是因为两者的样式基本是一致的-->
    <div class="classpop-mask" v-if="changeLessonShow">
      <div class="classpop">
        <h2 class="title">{{$t('m.class_modify_sectionTitle')}}</h2>
        <p class="row">
          <span class="left">{{$t('m.cou_n_course_title')}}</span>
          <input type="text"
                 class="input-name"
                 v-model="lessonname"
                 :placeholder="$t('m.cou_n_course_input_title')"
                 maxlength="20">
        </p>
        <p class="row">
          <span class="left">{{$t('m.cou_n_course_type')}}</span>
          <el-cascader
            :options="firstType"
            v-model="selectedOptions"
            size="small"
            @change="handleCoverChange">
          </el-cascader>
        </p>
        <div class="cover-row">
          <span class="left">{{$t('m.cou_n_course_cover')}}</span>
          <span class="right">
            <span class="img-wrapper">
              <img class="img" :src="imgurl" alt="cover" width="150" height="100">
            </span>
            <div class="upload-button-wrapper">
              <!--<vue-core-image-upload-->
              <!--class="upload-button"-->
              <!--crop="local"-->
              <!--:text="$t('m.select_img')"-->
              <!--:cropBtn="{ok:'确定','cancel':'取消'}"-->
              <!--cropRatio="3:2"-->
              <!--@imageuploaded="imageuploaded"-->
              <!--:max-file-size="5242880"-->
              <!--:url="imgUpUrl">-->
              <!--</vue-core-image-upload>-->
              <!--<span class="hint">{{$t('m.suggest')}}</span>-->
              <button class="upload-button" @click="queryCoverList">选择封面</button>
            </div>
          </span>
        </div>
        <div class="split"></div>
        <div class="add-introduce">
          <span class="left">{{$t('m.cou_n_course_introduce')}}</span>
          <div class="right">
            <template v-for="(item,index) in introduceList">
              <div class="text-wrapper" v-if="item.isImage===false">
                <textarea class="text" v-model='item.text' name="text" cols="30" rows="10"
                          placeholder="请填写课程的特点，适合人群，是否可以定制等信息，最好是图片和文字结合，介绍越详细越容易吸引学生报名"></textarea>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>
              <div class="img-wrapper" v-if="item.isImage===true">
                <div class="img-left">
                  <img class='showimg' :src="introduceImgUrl(item)" alt="img" width="100" height="100"><input
                  class="input" type="file" accept="image/*" @change="upImg(index,$event)"/>
                </div>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>

            </template>
            <button class="add" @click="addText">{{$t('m.addtext')}}</button>
            <button class="add" @click="addImage">{{$t('m.addimg')}}</button>
          </div>
        </div>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="changeLessonShow=false">{{$t('m.cancel')}}</button>
          <button class="btn confirm" @click="confirmChangeLesson">{{$t('m.confirm')}}</button>
        </div>
      </div>
    </div>
    <div class="coverpop-mask" v-if="coverShow">
      <div class="coverpop">
        <button class="close-btn" @click="coverShow=false;changeLessonShow=true;">
          <img src="./close.png" alt="关闭" width="14" height="14" style="vertical-align: top">
        </button>
        <h2 class="title">选择封面</h2>
        <section class="cover-wrapper">
          <template v-for="(item,index) in coverList" v-if="!isEmpty(coverList)">
            <section class="coverimg-wrapper" @click="selectCover(item)">
              <img :src="imgprefix+item.faceimg" alt="课程封面" width="165" height="110">
              <span class="circle">
                <span class="in-circle" v-if="coverId==item.id"></span>
              </span>
            </section>
          </template>
          <template v-if="isEmpty(coverList)">
            <p class="noresult" style="font-size:16px;color:#333;font-weight:bold;text-align: center">
              暂无系统课程封面，您可以上传自己的本地图片</p>
          </template>
        </section>
        <section class="btn-wrapper">
          <button class="confirm-btn" @click="confirmCover">确认</button>
          <vue-core-image-upload
            class="upload-button"
            crop="local"
            text="选择本地图片"
            :cropBtn="{ok:'确定','cancel':'取消'}"
            cropRatio="3:2"
            @imageuploaded="imageuploaded"
            :max-file-size="5242880"
            :url="imgUpUrl">
          </vue-core-image-upload>
          <span class="hint">建议上传720*480的图片，大小不超过5M</span>
        </section>
      </div>
    </div>
    <!--新建班级弹出框-->
    <div class="classpop-mask" v-if="newClassShow">
      <div class="classpop">
        <h2 class="title">{{$t(classDisplay.title)}}</h2>
        <p class="row">
          <span class="left">{{$t('m.bj_mode')}}</span>
          <select name="type"
                  id="classmode"
                  class="type-select"
                  :class="{'disable':classDisplay.propertyDisabled}"
                  v-model="classmode"
                  :disabled="classDisplay.propertyDisabled">
            <option disabled selected value="">{{$t('m.bj_select')}}</option>
            <option v-for="item in classModeList" :value="item.id">{{decodeURIComponent(item.name)}}</option>
          </select>
        </p>
        <p class="row">
          <span class="left">{{$t('m.bj_name')}}</span>
          <input type="text" class="input-name" v-model="classname" :placeholder="$t('m.bj_words')" maxlength="10">
        </p>
        <p class="row">
          <span class="left">{{$t('m.bj_type')}}</span>
          <select name="type"
                  id="classtype"
                  class="type-select"
                  v-model="democlass"
                  :class="{'disable':classDisplay.disabled}"
                  :disabled="classDisplay.disabled">
            <option value="1" selected>{{$t('m.bj_free')}}</option>
            <option value="0">{{$t('m.bj_charge')}}</option>
          </select>
        </p>
        <div class="split"></div>
        <template v-if="democlass==='1'">
          <p class="row">
            <span class="left">{{$t('m.bj_price')}}</span>
            <input
              type="text"
              class="input-price"
              maxlength="8"
              :value="num"
              @keyup="priceChange">
            <span class="text" style="margin-left:8px;">{{$t('m.bj_yuan')}}</span>
          </p>
          <div class="price">
            <span class="text small">{{$t('m.bj_fee')}}</span>
            <span class="text big">{{$t('m.bj_free_text')}}</span>
            <span class="text delete">{{$t('m.bj_orginal_price')}}¥{{num}}</span>
          </div>
        </template>
        <template v-if="democlass==='0'">
          <p class="row">
            <span class="left">{{$t('m.bj_startdate')}}</span>
            <span class="right">
              <el-date-picker
                v-model="startDateValue"
                type="date"
                :disabled="classDisplay.propertyDisabled"
                :picker-options="pickerOptions"
                size="medium"></el-date-picker>
            </span>
          </p>
          <p class="row">
            <span class="left">{{$t('m.bj_time')}}</span>
            <span class="right">
            <el-time-picker
              v-model="startTime"
              :disabled="classDisplay.propertyDisabled"
              :editable="false"
              placeholder="开始时间"
              format="HH:mm"
              size="medium"></el-time-picker>
            <span class="text" style="padding:0 6px">至</span>
            <el-time-picker
              v-model="endTime"
              :disabled="classDisplay.propertyDisabled"
              :editable="false"
              placeholder="结束时间"
              format="HH:mm"
              size="medium"></el-time-picker>
            </span>
          </p>
          <div class="row">
            <span class="left">课程周期：</span>
            <p class="select-week" @click="showWeek" :class="{'disable':classDisplay.propertyDisabled}">
              <template v-if="weekText==''">请选择适合自己的周期</template>
              <span class="weektext" v-else>{{weekText}}</span>
            </p>
            <div class="week-select-wrapper" v-if="weekShow">
              <template v-for="(item,index) in weekList">
                <span class="week-item" :class="{'now':item.show}" @click="item.show=!item.show">{{item.name}}</span>
              </template>
              <div class="week-btn-wrapper">
                <button class="week-confirm" @click="confirmWeek">确定</button>
                <button class="week-cancel" @click="weekShow=false">取消</button>
              </div>
            </div>
          </div>
          <p class="row">
            <span class="left">{{$t('m.bj_number')}}</span>
            <input
              type="text"
              :class="{'disable':classDisplay.propertyDisabled}"
              :disabled="classDisplay.propertyDisabled"
              class="input-price"
              maxlength="3"
              :value="integer2"
              @keyup="integerChange2">
          </p>
          <p class="row">
            <span class="left">{{$t('m.bj_unitprice')}}</span>
            <input
              type="text"
              :class="{'disable':classDisplay.propertyDisabled}"
              :disabled="classDisplay.propertyDisabled"
              class="input-price"
              maxlength="8"
              :value="num3"
              @keyup="priceChange3">
            <span class="text" style="margin-left:8px;">{{$t('m.bj_yuan')}}</span>
          </p>
          <div class="price">
            <span class="text small">{{$t('m.bj_fee')}}</span>
            <span class="text big">¥{{totalPrice2}}</span>
          </div>
        </template>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="newClassShow=false">{{$t('m.cancel')}}</button>
          <button class="btn confirm" @click="modifyClass">{{$t('m.confirm')}}</button>
        </div>
      </div>
    </div>
    <!--复制班级弹出框-->
    <copy-pop ref='popcopy' title="复制班级--" subtitle="设置开课时间" :classinfo="classinfo" @confirm="confirmCopy"></copy-pop>
    <!--删除班级弹出框-->
    <message-pop ref='popdelete'
                 :title="'m.class_delete_text'"
                 @confirm="confirmDelete"
                 :classid="classid"></message-pop>
    <!--下架班级弹出框-->
    <message-pop ref='popoffgrounding'
                 :title="'m.class_offsell_text'"
                 @confirm="confirmOffgrounding"
                 :classid="classid"></message-pop>

    <!--添加授课老师，此处的类型同添加课件是一样的-->
    <div class="warePop" v-if="warePopShow">
      <div class="ware-content-wrapper">
        <h3 class="ware-title">{{$t('m.class_addteacher_sectionTitle')}}</h3>
        <div class="flex-wrapper">
          <p class="left">{{$t('m.class_addteacher_teacherNow')}}{{decodeURIComponent(lessonTeacher.teachername)}}</p>
          <p class="right" @click="showAddTeacherQRCOde">{{$t('m.class_addteacher_inviteTeacher')}}</p>
        </div>
        <div class="ware-wrapper">
          <template v-for="(item,index) in schoolTeachers">
            <div class="classware">
              <img class="cover" :src="computeUrl(item.faceimg)" alt="cover" width="60" height="60">
              <div class="classware-middle">
                <h3 class="title">{{decodeURIComponent(item.teachername)}}</h3>
                <p class="introduce">{{decodeURIComponent(item.typename)}}</p>
              </div>
              <img v-if="item.show===false"
                   @click="show(item,index)"
                   class="del"
                   src="./beforeSelect.png"
                   alt="delete-button" width="20"
                   height="20">
              <img v-if="item.show===true"
                   @click="notShow(item,index)"
                   class="del"
                   src="./selected.png"
                   alt="delete-button" width="20"
                   height="20">
            </div>
          </template>
        </div>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="warePopShow=false;">{{$t('m.cancel')}}</button>
            <button class="confirm" @click="confirmAddTeacher">{{$t('m.confirm')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!--邀请老师二维码-->
    <qr-code-pop ref="popqrcode"
                 :title="'m.class_inviteteacher_sectionTitle'"></qr-code-pop>
    <!--分享课程二维码-->
    <share-school-page ref="sharelesson"
                       :schoolinfo="schoolNow"
                       :lessoninfo="lessoninfo"
                       :title="'m.class_share_sectionTitle'"></share-school-page>
    <!--分享班级二维码-->
    <!--<share-school-page ref="shareclass"-->
                       <!--:schoolinfo="schoolNow"-->
                       <!--:lessoninfo="lessoninfo"-->
                       <!--:classinfo="shareClassinfo"-->
                       <!--:title="'m.class_share_text'"></share-school-page>-->
    <div class="videopop-wrapper" v-if="videoShow">
      <div class="videopop">
        <h2 class="title">{{$t('m.class_makedemovideo')}}</h2>
        <p class="row">
          <span class="left">{{$t('m.class_v_step1')}}</span>
          <input
            type="text"
            class="input-price"
            maxlength="3"
            :value="videoInteger"
            @keyup="videoIntegerChange">
          <span class="text" style="margin-left: 10px;">{{$t('m.class_v_minute')}}</span>
          <span class="hint">{{$t('m.class_v_hint')}}</span>
        </p>
        <p class="row">
          <span class="left">{{$t('m.class_v_step2')}}</span>
          <select name="type"
                  class="type-select"
                  :class="{'default':videoSelect==='default'}"
                  v-model="videoSelect">
            <option disabled selected value="default" class="select-hint">{{$t('m.class_v_hint2')}}</option>
            <template v-if="lessonWareList">
              <option class="select-item"
                      v-for="item in lessonWareList"
                      :value="item.sceneid">{{decodeURIComponent(item.coursewarename)}}
              </option>
            </template>
          </select>
        </p>
        <p class="row">
          <span class="left">{{$t('m.class_v_step3')}}</span>
          <button class="play"
                  @click="goMakeVideo">
            <img src="./video-play.png" alt="play-icon" width="20" height="20">{{$t('m.class_v_gomake')}}
          </button>
        </p>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="videoShow=false;">{{$t('m.cancel')}}</button>
            <button class="confirm" @click="QueryRecordCourseWare">{{$t('m.class_v_next')}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="videopreview-wrapper" v-if="videoPreviewShow">
      <div class="videopreview">
        <img class="video-close" @click="videoPreviewShow=false" src="./close.png" alt="close" width="20" height="20">
        <h2 class="title">{{$t('m.class_v_preview')}}</h2>
        <div class="img-wrapper">
          <img v-if="demofaceimg"
               :src="imgprefix+demofaceimg"
               alt="demo" width="300" height="200">
          <div class="video-mask">
            <img class="video-preview"
                 src="./video-preview.png"
                 @click="goVideoPreview"
                 alt="preview-icon" width="70" height="70">
          </div>
        </div>
        <p class="re-video">{{$t('m.class_v_notSatisfied1')}}“<span class="color"
                                                                    @click="reMakeVideo">{{$t('m.class_v_notSatisfied2')}}</span>”
        </p>
        <button class="upload-btn" @click="SetLessonDemo">{{$t('m.class_v_upload')}}</button>
      </div>
    </div>
    <!--<router-view></router-view>-->

  </div>
</template>

<script type="text/ecmascript-6">
  import shareSchoolPage from 'components/shareschoolpage/ShareSchoolPage'
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav'
  import {toMinutes} from 'common/js/toMinutes.js';
  import messagePop from 'components/messagepop/MessagePop';
  import copyPop from 'components/copypop/CopyPop'
  import Vue from 'vue';
  import qrCodePop from 'components/qrcodepop/QRCodePop'
  import VueCoreImageUpload from 'vue-core-image-upload';
  import aboveNav from 'components/abovenav/AboveNav'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        topList: [
          {
            name: 'm.cou_top_bjgl',
            to: '/console/lesson/class',

          },
          {
            name: 'm.cou_top_kjgl',
            to: '/console/lesson/ware',
          },
//          {
//            name: 'm.cou_top_kcb',
//            to: '/console/lesson/schedule',
//          },
//          {
//            name: 'm.cou_top_kcyhq',
//            to: '/console/lesson/coupon'
//          },
//          {
//            name: '班级预约',
//            to: '/console/lesson/appoint',
//          },
//          {
//            name: '课程评价',
//            to: '/console/lesson/rate',
//          },
        ],
        radioSelect: '显示全部',
        //-----------以下内容开始和添加老师有关-----------//
        lessonTeacher: {teachername: ''},
        schoolTeachers: [],         //该网校老师列表
        warePopShow: false,
        //-----------以下内容开始和修改课程有关-----------//
        lessonPreviewShow: false,
        firstType: (() => loadLocal('firstType', false))(),             //第一大分类
        secondType: (() => loadLocal('secondType', false))(),            //第二大分类
        thirdType: (() => loadLocal('thirdType', false))(),             //第三大分类
        selectedOptions: [],      //表示选中的选项
        changeLessonShow: false,
        lessonname: '',
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./cover.png'),
        upurl: '',
        //---------------选择封面------------------//
        coverShow: false,
        coverList: [],
        coverId: null,
        //-----------以下内容开始和分享课程有关-----------//
        shareClassinfo: undefined,
        //-----------以下内容开始和创建班级有关-----------//
        classDisplay: {
          title: '创建班级',
          disabled: false,        //控制班级类型能否修改，若为修改班级，则为true（不能修改）
          propertyDisabled: false, //控制班级姓名等能否修改，若班级已有人报名，则为true（不能修改）
          btnMessage: '创建',
          isCreate: true,
        },
        newClassShow: false,
        classmode: '',             //上传的上课模式
        classname: '',              //上传的班级名称
        democlass: '1',             //班级类型
        startDateValue: '',         //开课日期
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < (Date.now() - 3600 * 24 * 1000);
          }
        },
        isFalse: false,
        isTrue: true,
        startTime: null,   //上课时间
        endTime: null,
        weekList: [
          {value: '0', name: '周日', show: false},
          {value: '1', name: '周一', show: false},
          {value: '2', name: '周二', show: false},
          {value: '3', name: '周三', show: false},
          {value: '4', name: '周四', show: false},
          {value: '5', name: '周五', show: false},
          {value: '6', name: '周六', show: false},
        ],
        weekShow: false,
        weekText: '',
        classcycle: '',
        classdeadline: '0',
        classperiod: '',
        inputNum: '',
        inputNum3: '',
        inputNum4: '',
        inputInteger: '',
        inputInteger2: '',
        setCost: false,
        introduceList: [],
        index: 0,        //根据上传图片确定index，从而对相应的list[this.index]赋值
        //---------以下内容开始和复制班级有关----------------//
        classinfo: null,           //点击复制按钮，向copypop组件传入的参数，Object类型
        //---------以下内容开始和删除班级有关----------------//
        classid: 0,                //点击下架、删除向messagepop组件传入的参数，Number类型
        //---------以下内容开始和页码有关----------------//
        currentPage: 1,
        totoalPage: 0,
        //---------以下内容和视频录制有关----------------//
        videoShow: false,
        lessonWareList: null,
        videoSelect: 'default',       //选中的课件
        inputVideoInteger: '',
        videoPreviewShow: false,
        demofaceimg: null,
        previewInfo: null,
        //---------以下内容为页面生成时从服务端获取的数据----------------//
        classModeList: [],       //服务端获取到的上课模式，如1对1、1对2...
        classPeriodList: [],     //服务端获取到的课程周期，如每天上课、隔天上课
        classList: [],
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeTotalHour(item) {
        let hour = Math.floor(item / 60);
        let minutes = item % 60;
        return `${hour}小时${minutes}分钟`
      },
      cutIntroduce(introduce) {
        if (introduce === '') {
          return ''
        } else {
          let list = JSON.parse(decodeURIComponent(introduce));
          for (let i = 0; i < list.length; i++) {
            if (list[i].isImage === false && list[i].text !== '') {
              if (list[i].text.length > 100) {
                return list[i].text.substring(0, 100);
              }
              return list[i].text;
            }
          }
        }
        return '';
      },
      //-------------------添加校内老师----------------------//
      showAddTeacher() {
        //接口：查询网校老师列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Teacher',
            a: 'QueryTeachers',
            id: this.id,
            rid: this.schoolNow.rid
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code == 200) {
            this.schoolTeachers = response.list;
            if (this.schoolTeachers != null) {
              this.schoolTeachers.forEach(function (ele) {
                ele.show = false;
              })
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

        //接口：查询某门课程的老师资料
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Teacher',
            a: 'QueryLessonTeacher',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 101) {
            this.lessonTeacher.teachername = '暂无课程老师'
          }
          if (response.code === 200) {
            this.lessonTeacher = response.list[0];
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

        this.warePopShow = true;
      },
      computeUrl(url) {
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      show(item, index) {
        this.schoolTeachers.forEach(function (ele) {
          ele.show = false;
        });
        Vue.set(this.schoolTeachers[index], 'show', true);
        this.$forceUpdate();
      },
      notShow(item, index) {
        Vue.set(this.schoolTeachers[index], 'show', false);
        this.$forceUpdate();
      },
      confirmAddTeacher() {
        if (this.schoolTeachers.length === 0) {
          this.$message({
            message: '请先选择老师',
            type: 'warning',
          });
        } else {
          let teacheruserid = '';
          for (let i = 0; i < this.schoolTeachers.length; i++) {
            if (this.schoolTeachers[i].show === true) {
              teacheruserid = this.schoolTeachers[i].userid;
            }
          }
          if (teacheruserid === '') {
            this.$message({
              message: '请先选择老师',
              type: 'warning',
            });
          } else {
            //接口：更新指定用户课程（更新对应的teacheruserid即可）
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'Lesson',
                a: 'UpdateLesson',
                id: this.id,
                rid: this.schoolNow.rid,
                lessonid: this.lessoninfo.id,
                teacheruserid: teacheruserid,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
              }
              if (response.code == 200) {
                this.$message({
                  message: '添加老师成功',
                  type: 'success'
                });
                this.warePopShow = false;
              }
            }).catch((err) => {
              this.$alert('请求失败，请重试', '提示', {
                confirmButtonText: '确定',
              });
            });
          }
        }
      },
      //预览课程
      //根据当前introduceList的值，返回相应的数据
      computeLessonIntroduceList(list) {
        if (this.isEmpty(list)) {
          return '';
        } else {
          return JSON.parse(decodeURIComponent(list));
        }
      },
      showAddTeacherQRCOde() {
        this.warePopShow = false;
        this.$refs.popqrcode.show();
      },
      //打开修改课程界面
      showChangeLesson() {
        let array = [];
        if (!this.isEmpty(this.lessoninfo)) {
          array[0] = this.lessoninfo.maintype + '';
          array[1] = this.lessoninfo.subtype + '';
          if (this.lessoninfo.thirdtype !== 0) {
            array[2] = this.lessoninfo.thirdtype + '';
          }
          this.imgurl = this.imgprefix + this.lessoninfo.faceimg;
          this.upurl = this.lessoninfo.faceimg;
          //课程的课程标题
          this.lessonname = decodeURIComponent(this.lessoninfo.lessonname);
          this.selectedOptions = array;
          if (this.lessoninfo.introduce == '') {
            this.introduceList = [];
          } else {
            this.introduceList = JSON.parse(decodeURIComponent(this.lessoninfo.introduce));
          }
        }
        //获取课程分类
        if (this.firstType === false) {
          this.loadLessonType();
        }
        this.changeLessonShow = true;

      },
      selectCover(item) {
        this.coverId = item.id;
        this.imgurl = this.imgprefix + item.faceimg;
        this.upurl = item.faceimg;
      },
      handleCoverChange() {
        this.imgurl = require('./cover.png');
        this.upurl = '';
      },
      confirmCover() {
        if (this.coverId == null) {
          this.$message({
            message: '请选择课程封面',
            type: 'warning'
          });
          return;
        }
        this.changeLessonShow = true;
        this.coverShow = false;
      },
      queryCoverList() {
        if (this.isEmpty(this.selectedOptions)) {
          this.$message({
            message: '请选择课程分类',
            type: 'warning'
          });
          return;
        }
        let params = {
          c: 'Lesson',
          a: 'QueryCoverSource',
          id: this.id,
          pageno: 1,
          pagesize: 30,
          maintype: this.selectedOptions[0],
          subtype: this.selectedOptions[1]
        };
        if (this.selectedOptions[2]) {
          params.thirdtype = this.selectedOptions[2];
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.coverId = null;
            this.imgprefix = response.imgprefix;
            this.changeLessonShow = false;
            this.coverShow = true;
            this.coverList = response.list;
            this.$forceUpdate();
          }
          if (response.code == 101) {
            this.coverId = null;
            this.coverList = [];
            this.changeLessonShow = false;
            this.coverShow = true;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.loadLessonType();
        });
      },
      //分享课程界面
      showShareLesson() {
        this.shareClassinfo = undefined;
        this.$refs.sharelesson.show();
      },
      //修改课程，同新建课程类似，只是多了introduce部分
      confirmChangeLesson() {
        if (this.lessonname === '') {
          this.$message({
            message: '请输入课程名称',
            type: 'warning'
          });
          return;
        }
        if (this.isEmpty(this.selectedOptions)) {
          this.$message({
            message: '请选择课程分类',
            type: 'warning'
          });
          return;
        }
        if (this.upurl === '') {
          this.$message({
            message: '请上传课程封面',
            type: 'warning'
          });
          return;
        }
        if (this.computeUpIntroduceList(this.introduceList) === '') {
          this.$message({
            message: '请填写课程介绍',
            type: 'warning'
          });
          return;
        }
        let typename = '';
        //如何使用axios传入post参数
        //https://jingyan.baidu.com/album/29697b916d6a7bab20de3cf9.html?picindex=3
        let params = new URLSearchParams();
        params.append('id', this.id);
        params.append('rid', this.schoolNow.rid);
        params.append('lessonid', this.lessoninfo.id);
        params.append('lessonname', this.lessonname);
        params.append('faceimg', this.upurl);
        params.append('maintype', this.selectedOptions[0]);
        params.append('subtype', this.selectedOptions[1]);

        for (let i = 0; i < this.firstType.length; i++) {
          if (this.firstType[i].id == this.selectedOptions[0]) {
            typename = this.firstType[i].name;
          }
        }
        for (let i = 0; i < this.secondType.length; i++) {
          if (this.secondType[i].id == this.selectedOptions[1]) {
            typename += '/' + this.secondType[i].name;
          }
        }
        if (this.selectedOptions.length === 3) {
          params.append('thirdtype', this.selectedOptions[2]);
          for (let i = 0; i < this.thirdType.length; i++) {
            if (this.thirdType[i].id == this.selectedOptions[2]) {
              typename += '/' + this.thirdType[i].name;
            }
          }
        }
        params.append('typename', typename);
        let introduce = this.computeUpIntroduceList(this.introduceList);
        params.append('introduce', introduce);
        params.append('returninfo', 1);

        //接口：更新指定用户课程
        this.$http({
          url: '/indexapp.php?c=Lesson&a=UpdateLesson',
          method: 'post',
          data: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.lessoninfo = response.list[0];
            this.$emit('changeLesson', this.lessoninfo);
            this.$message({
              message: '更新课程成功',
              type: 'success'
            });
            this.changeLessonShow = false;
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //时间位于招生截止日期前返回true
      beforeEnrollenddate: function (item) {
        let date = new Date();
        if (date.getTime() < new Date(item.enrollenddate).getTime()) {
          return true;
        } else {
          return false;
        }
      },
      //时间位于开课日期前返回true
      beforeStart(item) {
        let date = new Date();
        let last = new Date(item.startdate + ' ' + item.starttime);
        if (date.getTime() < last.getTime()) {
          return true;
        } else {
          return false;
        }
      },
      //时间位于最后一节课的截止时间，返回true
      beforeFinal(item) {
        let date = new Date();
        let last = new Date(item.enddate + ' ' + item.endtime);
        if (date.getTime() < last.getTime()) {
          return true;
        } else {
          return false;
        }
      },
      //点击添加班级
      showAddClass() {
        if (this.lessoninfo.lessontype === 1) { // 当为自有生源课程是 展示创建自有生源班级弹窗
          return this.$store.commit('setAddClassDialog', true)
        }
        this.classDisplay.title = 'm.class_new_class';
        this.classDisplay.disabled = false;
        this.classDisplay.propertyDisabled = false;
        this.classDisplay.isCreate = true;
        //重置弹出层的数据
        this.classmode = '';           //上传的班级模式
        this.classname = '';           //上传的班级名称
        this.democlass = '1';         //上传的班级类型
        this.startDateValue = '';       //开课日期
        this.startTime = null;
        this.endTime = null;
        this.inputNum = '';
        this.inputNum3 = '';
        this.inputNum4 = '';
        this.inputInteger = '';
        this.inputInteger2 = '';
        this.classdeadline = '0';
        this.classperiod = '';
        this.newClassShow = true;
      },
      priceChange(e) {
        this.inputNum = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      priceChange3(e) {
        this.inputNum3 = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      priceChange4(e) {
        this.inputNum4 = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      integerChange(e) {
        this.inputInteger = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      integerChange2(e) {
        this.inputInteger2 = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      videoIntegerChange(e) {
        this.inputVideoInteger = e.target.value;
        this.$forceUpdate()
      },
      //删除添加文字、添加图片的某一项
      del: function (index) {
        this.introduceList.splice(index, 1);
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。
      },
      //增加文字、图片的相关方法
      addText() {
        let oText = {
          "isImage": false,
          "text": '',
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      addImage() {
        let oText = {
          "isImage": true,
          "image": './addImage.png',
          "width": 0,
          "height": 0,
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      introduceImgUrl(item) {
        if (item.image == './addImage.png') {
          return require('./addImage.png');
        } else {
          return this.imgprefix + item.image;
        }
      },
      upImg: function (index, e) {
        this.index = index;
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let image = input.previousSibling;
          image.src = e.target.result;
        };
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$set(this.introduceList[this.index], 'image', jsonobj.image);
        this.$set(this.introduceList[this.index], 'width', jsonobj.imagewidth);
        this.$set(this.introduceList[this.index], 'height', jsonobj.imageheight);
        this.$forceUpdate();
      },
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 111) {
          this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
        } else if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
          this.changeLessonShow = true;
          this.coverShow = false;
        }
      },
      //-------------------以下内容开始和新建班级有关----------------------//
      showWeek() {
        //首先判断是否报名
        if (this.classDisplay.propertyDisabled == true) {
          return;
        } else {
          let weekNow = this.classcycle.split(',');
          this.weekList.forEach(function (item) {
            item.show = false;
          });
          for (let i = 0; i < weekNow.length; i++) {
            for (let j = 0; j < this.weekList.length; j++) {
              if (this.weekList[j].value === weekNow[i]) {
                this.weekList[j].show = true;
              }
            }
          }
          this.weekShow = true;
        }
      },
      //确认课程周期
      confirmWeek() {
        //计算课程周期返回的字段
        let weekText = '',
          classcycle = [];
        for (let i = 0; i < this.weekList.length; i++) {
          if (this.weekList[i].show == true) {
            weekText += this.weekList[i].name + ' ';
            classcycle.push(this.weekList[i].value);
          }
        }
        this.weekText = weekText;
        this.classcycle = classcycle.join(",");
        this.weekShow = false;
      },
      modifyClass() {
        let lang = loadLocal('language', false);
        if (this.classmode === '') {
          this.$message({
            message: lang === 'en' ? 'Please select class mode' : '请选择上课模式',
            type: 'warning'
          });
          return;
        }
        if (this.classname === '') {
          this.$message({
            message: lang === 'en' ? 'Please input class name' : '请输入班级名称',
            type: 'warning'
          });
          return;
        }

        if (this.democlass === '1') {
          if (this.num === '') {
            this.$message({
              message: lang === 'en' ? 'Please input price' : '请输入试听原价',
              type: 'warning'
            });
            return;
          }
          if (Number(this.num) > 10000) {
            this.$message({
              message: '试听原价不得超过10000',
              type: 'warning'
            });
            return;
          }
        } else {
          if (this.startDateValue === '') {
            this.$message({
              message: lang === 'en' ? 'Please select start date' : '请选择开课日期',
              type: 'warning'
            });
            return;
          }
          if (this.startTime === null || this.endTime === null) {
            this.$message({
              message: lang === 'en' ? 'Please select time' : '请选择上课时间',
              type: 'warning'
            });
            return;
          } else {
            //getTime() 方法可返回距 1970 年 1 月 1 日之间的毫秒数。
            let start = this.startTime.getTime();
            let end = this.endTime.getTime();
            if (start > end) {
              this.$message({
                message: lang === 'en' ? 'The end time should be greater than the start time' : '上课时间的结束时间应大于开始时间',
                type: 'warning'
              });
              return;
            }
          }
          if (this.classcycle === '') {
            this.$message({
              message: lang === 'en' ? 'Please select period' : '请选择课程周期',
              type: 'warning'
            });
            return;
          }
          if (this.integer2 === '') {
            this.$message({
              message: lang === 'en' ? 'Please input number' : '请输入课程次数',
              type: 'warning'
            });
            return;
          }
          if (this.num3 === '') {
            this.$message({
              message: lang === 'en' ? 'Please input unit price' : '请输入课程单价',
              type: 'warning'
            });
            return;
          }
          if (Number(this.num3) > 10000) {
            this.$message({
              message: '课程单价不得超过10000',
              type: 'warning'
            });
            return;
          }
        }
        //如果满足新建、修改班级的条件
        let url;
        let params = new URLSearchParams();
        params.append('id', this.id);
        params.append('rid', this.schoolNow.rid);
        params.append('lessonid', this.lessoninfo.id);
        //根据条件判断是创建班级还是修改班级
        if (this.classDisplay.isCreate === true) {
          url = '/indexapp.php?c=Lesson&a=AddClass';
        } else {
          url = '/indexapp.php?c=Lesson&a=UpdateClass';
          params.append('classid', this.classid);
        }
        //上课模式（1对1、1对2。。。）
        let modename = this.getModeName(this.classmode, this.classModeList);
        //分三种情形：1.对于新建班级，上传所有参数；2.对于修改班级（未报名），除了班级模式参数(democlass)，上传其余参数；3.对于修改班级（已报名），试听班仅可以修改班级名称和试听原价（即其余参数不需要上传），收费班仅可以修改班级名称

        //如果是试听课
        if (this.democlass === '1') {

          //新建班级,上传所有参数
          if (this.classDisplay.isCreate === true) {
            params.append('starttime', "12:00");
            params.append('endtime', "13:00");
            params.append('classname', this.classname);
            params.append('classmode', this.classmode);
            params.append('classmodename', modename);
            params.append('democlass', this.democlass);
            params.append('actualprice', 0);
            params.append('unitprice', this.num);
            params.append('totalprice', this.num);
            params.append('totalnumber', 1);
          } else {
            //修改班级（未报名）,除了班级模式参数，上传其余参数(由于是试听课，因此不需要上传actualprice)
            if (this.classDisplay.propertyDisabled == false) {
              params.append('classname', this.classname);
              params.append('classmode', this.classmode);
              params.append('classmodename', modename);
              params.append('unitprice', this.num);
              params.append('totalprice', this.num);
            } else {
              //修改班级（已报名），试听班仅可以修改班级名称和试听原价
              params.append('classname', this.classname);
              params.append('unitprice', this.num);
              params.append('totalprice', this.num);
            }
          }
        } else {
          let startdate = this.getStartDate(this.startDateValue);
          let starttime = this.getTime(this.startTime);
          let endtime = this.getTime(this.endTime);
          //新建班级,上传所有参数
          if (this.classDisplay.isCreate === true) {
            params.append('discount', 0);
            params.append('classmode', this.classmode);
            params.append('classmodename', modename);
            params.append('classname', this.classname);
            params.append('democlass', this.democlass);
            params.append('startdate', startdate);
            params.append('starttime', starttime);
            params.append('endtime', endtime);
            params.append('classcycle', this.classcycle);
            params.append('totalnumber', this.integer2);
            params.append('unitprice', this.num3);
            params.append('totalprice', this.totalPrice2);
            params.append('actualprice', this.totalPrice2);
          } else {
            //修改班级（未报名）,除了班级模式参数
            if (this.classDisplay.propertyDisabled == false) {
              params.append('discount', 0);
              params.append('classmode', this.classmode);
              params.append('classmodename', modename);
              params.append('classname', this.classname);
              params.append('startdate', startdate);
              params.append('starttime', starttime);
              params.append('endtime', endtime);
              params.append('classcycle', this.classcycle);
              params.append('totalnumber', this.integer2);
              params.append('unitprice', this.num3);
              params.append('totalprice', this.totalPrice2);
              params.append('actualprice', this.totalPrice2);
            } else {
              //修改班级（已报名），试听班仅可以修改班级名称和试听原价
              params.append('classname', this.classname);
            }
          }
        }
        //接口：指定用户新建课程
        this.$http({
          url: url,
          method: 'post',
          data: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.newClassShow = false;
            let text;
            if (this.classDisplay.isCreate === true) {
              text = '添加班级成功'
            } else {
              text = '修改班级成功'
            }
            this.$message({
              message: text,
              type: 'success'
            });
            this.loadClassList(1);
            this.currentPage = 1;
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })

      },
      //根据当前introduceList的值，返回相应的符合上传需求的数据
      computeUpIntroduceList(list) {
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isImage === true) {
              if (list[i].width === 0) {
                continue;
              }
            } else {
              if (list[i].text === '') {
                continue;
              }
            }
            result.push(list[i]);
          }
          if (this.isEmpty(result)) {
            return '';
          }
          result = JSON.stringify(result);
          result = encodeURIComponent(result);
          return result;
        }
      },
      //获取开始日期时间
      getStartDate(time) {
        return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
      },
      //获取班级结束日期
      getEndDate(start, number, interval) {
        start = new Date(start).getTime();     //getTime() 方法可返回距 1970 年 1 月 1 日之间的毫秒数(ms)
        number = Number(number) - 1;
        interval = Number(interval);
        let intervalTime = number * interval * 1000 * 3600 * 24;
        let end = start + intervalTime;
        let date = new Date(end);
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      },
      //获取上课开始时间和上课截止时间
      getTime(time) {
        return time.getHours() + ':' + time.getMinutes();
      },
      //获取上课模式名字
      getModeName(classmode, classModeList) {
        for (let i = 0; i < classModeList.length; i++) {
          //因为从服务端获取到的为字符串，而classModeList的类型为数字，因此必须使用==，而不是全等
          if (classmode == classModeList[i].id) {
            return decodeURIComponent(classModeList[i].name);
          }
        }
      },
      //跳至班级的信息界面
      gotoClassSchedule(item) {
        saveLocal('classinfo', item);
        this.$router.push('/console/lesson/class/schedule');
      },
      //打开直播列表，即跳至“课程表”页面
      openLive(item) {
        saveLocal('classinfo', item);
        this.$router.push('/console/lesson/class/schedule');
      },
      //根据当前课程是否有老师，判断能否上架
      whetherGrounding(classid) {
        //如果该课程的老师不为空，则直接调用grounding（上线）函数，如果为空，通过接口查询该课程的老师资料确认是否为空（该情况发生在，本来该课程无老师，添加老师后，当前页面的lessoninfo信息没有得到更新，因此需要查询老师）
        if (this.lessoninfo.teacheruserid !== '') {
          this.grounding(classid);
        } else {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'Teacher',
              a: 'QueryLessonTeacher',
              id: this.id,
              rid: this.schoolNow.rid,
              lessonid: this.lessoninfo.id,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 101) {
              this.$message({
                message: '课程添加授课老师才可以招生',
                type: 'warning'
              });
            }
            if (response.code === 200) {
              this.grounding(classid);
            }
          }).catch((err) => {
            this.$alert('未获取到数据，请重新加载页面', '提示', {
              confirmButtonText: '刷新',
              callback: action => {
                window.location.reload();
              }
            });
          });
        }
      },
      //上架
      grounding: function (classid) {
        //接口：修改班级资料（ispublish：是否上架1为上架，0为下架）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'UpdateClass',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            classid: classid,
            ispublish: '1',
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            //如果上架成功，则根据当前list查询对应id，并将其ispublich修改为1（上架）
            for (let i = 0; i < this.classList.length; i++) {
              if (this.classList[i] == undefined) {
                continue;
              } else if (this.classList[i].id == classid) {
                Vue.set(this.classList[i], 'ispublish', 1);
              }
            }
            this.$message({
              message: '班级上架成功',
              type: 'success'
            });
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          console.log(err)
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //点击下架按钮，弹出弹出层，赋值classid并通过props传入messagepop组件
      offgrounding: function (item) {
        this.classid = item.id;
        this.$refs.popoffgrounding.show();
      },
      //确定下架班级
      confirmOffgrounding: function (classid) {
        //接口：修改班级资料（ispublish：是否上架1为上架，0为下架）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'UpdateClass',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            classid: classid,
            ispublish: '0',
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            //如果上架成功，则根据当前list查询对应id，并将其ispublich修改为1（上架）
            for (let i = 0; i < this.classList.length; i++) {
              if (this.classList[i] == undefined) {
                continue;
              } else if (this.classList[i].id == classid) {
                Vue.set(this.classList[i], 'ispublish', 0);
              }
            }
            this.$refs.popoffgrounding.hide();
            this.$message({
              message: '班级下架成功',
              type: 'success'
            });
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //点击分享，分享班级
      showShareClass(item) {
        this.shareClassinfo = item;
        setTimeout(() => {
          this.$refs.shareclass.show();
        }, 500)


      },
      //点击复制icon，打开复制弹出层
      openCopy(item) {
        this.classinfo = item;
        this.$refs.popcopy.show();
      },
      //复制弹出层，点击确定按钮
      confirmCopy(copyinfo) {
        //接口：复制指定班级
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'CopyClass',
            id: this.id,
            rid: this.schoolNow.rid,                //网校id
            classid: copyinfo.classid,
            startdate: copyinfo.startdate,
            starttime: copyinfo.starttime,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.loadClassList(1);
            this.currentPage = 1;
            this.$message({
              message: '复制班级成功',
              type: 'success'
            });
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //修改班级
      showChangeClass(item) {
        //如果有人报名
        if (item.enrollnums !== 0) {
          this.classDisplay.propertyDisabled = true;
        } else {
          this.classDisplay.propertyDisabled = false;
        }
        //修改弹出框的文字显示
        this.classDisplay.title = 'm.class_modify_class';
        this.classDisplay.disabled = true;
        this.classDisplay.isCreate = false;
        //以下修改的是数据部分
        this.classid = item.id;
        this.classname = decodeURIComponent(item.classname);
        this.classmode = item.classmode;

        //如果是试听班
        if (item.democlass === '1') {
          this.democlass = '1';
          this.inputNum = '' + item.unitprice;
          //如果试听班的实际价格不为0，则证明用户设置了试听价
        } else if (item.democlass === '0') {
          this.democlass = '0';
          this.startDateValue = new Date(item.startdate);
          this.startTime = new Date('2016-9-10' + ' ' + item.starttime);
          this.endTime = new Date('2016-9-10' + ' ' + item.endtime);

          this.inputNum4 = '';
          this.inputInteger = '';
          this.inputNum3 = '' + item.unitprice;
          this.inputInteger2 = '' + item.totalnumber;
          this.classcycle = item.classcycle;
          let tempClassCycleArray = item.classcycle.split(',');
          let weekText = '';
          for (let i = 0; i < this.weekList.length; i++) {
            for (let j = 0; j < tempClassCycleArray.length; j++) {
              if (tempClassCycleArray[j] === this.weekList[i].value) {
                weekText += this.weekList[i].name + ' ';
              }
            }
          }
          this.weekText = weekText;
        }
        this.$forceUpdate();
        this.newClassShow = true;
      },
      //弹出删除
      openDelete(classid) {
        this.classid = classid;
        this.$refs.popdelete.show();
      },
      confirmDelete: function (classid) {
        //接口：删除指定班级（未上线的班级可以删除）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'DeleteClass',
            id: this.id,
            rid: this.schoolNow.rid,                //网校id
            classid: classid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.loadClassList(1);
            this.currentPage = 1;
            this.$refs.popdelete.hide();
            this.$message({
              message: '删除班级成功',
              type: 'success'
            });
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
            this.$refs.popdelete.hide();
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //改变页码时
      handleCurrentChange(val) {
        this.loadClassList(val);
      },
      //-------------------以下内容为制作视频---------------------//
      goMakeVideo() {
        if (this.videoInteger === '') {
          this.$message({
//            message: lang === 'en' ? 'Please select class mode' : '请选择上课模式',
            message: '请输入录制时间',
            type: 'warning'
          });
          return;
        }
        if (this.videoSelect === 'default') {
          this.$message({
//            message: lang === 'en' ? 'Please select class mode' : '请选择上课模式',
            message: '请选择录制课件',
            type: 'warning'
          });
          return;
        }
        let newWindow = window.open();
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHistory',
            a: 'GetRecordDemoDatas',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            lessontime: this.videoInteger,
            coursewareid: this.videoSelect,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            let id = this.id;
            let classid = response.classid;
            let rid = response.rid;
            let lessonid = response.lessonid;
            let catalogindex = response.catalog_index;
            let catalogid = response.catalogid;
            newWindow.location.href = `${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`;
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      QueryRecordCourseWare(from) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHistory',
            a: 'QueryRecordVideoFile',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
          }
        }).then((response) => {
          response = response.data;
          // status：0->未录制； 1->已录制
          if (response.status === 0) {
            if (from === 'outside') {
              this.videoShow = true;
              return;
            }
            this.$message({
              message: '未检测到录制视频，请先完成视频录制',
              type: 'warning'
            });
          } else {
            this.videoShow = false;
            this.videoPreviewShow = true;
            this.demofaceimg = response.lessonfaceimg;
            this.previewInfo = response;
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //视频预览
      goVideoPreview() {
        let id = this.id;
        let response = this.previewInfo;
        let classid = response.classid;
        let rid = response.rid;
        let lessonid = response.lessonid;
        let catalogindex = response.catalog_index;
        let catalogid = response.catalogid;
        window.open(`${this.GLOBAL.liveUrl}/review.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      //重新制作新课件
      reMakeVideo() {
        this.videoSelect = 'default';
        this.inputVideoInteger = '';
        this.videoShow = true;
        this.videoPreviewShow = false;
      },
      //上传视频
      SetLessonDemo() {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHistory',
            a: 'SetLessonDemo',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.$message({
              message: '上传成功',
              type: 'success'
            });
            this.videoPreviewShow = false;
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });

          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //-------------------以下内容为从服务器获取初始数据----------------------//
      //获取上课模式列表
      loadClassModeList() {
        let lang = loadLocal('language', false);
        let upLang = '';
        if (lang === 'en') {
          upLang = 'en';
        }
        //接口：返回开班模式列表（id不是必须值）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCatalog',
            a: 'QueryClassModeList',
            lang: upLang,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.classModeList = response.list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //获取班级列表
      loadClassList(page) {
        this.classList = [];
        //接口：查询班级列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryClass',
            rid: this.schoolNow.rid,                //网校id
            lessonid: this.lessoninfo.id,
            pageno: page,
            pagesize: 6,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            for (let i = 0; i < response.list.length; i++) {
              this.classList[(page - 1) * 6 + i] = response.list[i];
            }
            this.totoalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      //获取课程的分类
      loadLessonType() {
        let i = 0;
        //获取第一大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonType',
            parentid: 0
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.firstType = response.list;
            this.nameOption(this.firstType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType, this.thirdType);
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

        //获取第二大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonSecondType'
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.secondType = response.list;
            this.nameOption(this.secondType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType, this.thirdType);
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

        //获取第三大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonThirdType',
            thirdtypeid: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.thirdType = response.list;
            this.nameOption(this.thirdType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType, this.thirdType);
            }
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      //将从服务器获取到的数据增加value字段和label字段
      nameOption(obj) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].value = obj[i].id;
          obj[i].label = obj[i].name;
        }
      },
      //获取课程的课件列表
      QueryCourseWares() {
        //接口：查询课程的课件列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'QueryCourseWares',
            id: this.id,
            queryrid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            pageno: 1,
            pagesize: 100,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          this.lessonWareList = response.list;
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //将created中异步获取的分类列表合并为适合el-cascader的options
      mergeOption: function (first, second, third) {
        //将第三大类插入第二大类中
        for (let i = 0; i < second.length; i++) {
          if (second[i].thirdtypeid == 1) {
            second[i].children = third;
          }
        }
        saveLocal('secondType', this.secondType);
        saveLocal('thirdType', this.thirdType);
        for (let j = 0; j < first.length; j++) {
          first[j].children = [];
          for (let k = 0; k < second.length; k++) {
            if (second[k].parentid == first[j].id) {
              first[j].children.push(second[k]);
            }
          }
        }
        saveLocal('firstType', this.firstType);
      },
    },
    computed: {
      num() {
        return this.inputNum.replace(/[^\d.]/g, "") //清除‘数字’和‘.’以外的字符
          .replace(/^\./g, "")              //验证第一个字符是数字而不是.
          .replace(/\.{2,}/g, ".")          //只保留第一个.清除多余的.
          .replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      },
      num3() {
        return this.inputNum3.replace(/[^\d.]/g, "") //清除‘数字’和‘.’以外的字符
          .replace(/^\./g, "")              //验证第一个字符是数字而不是.
          .replace(/\.{2,}/g, ".")          //只保留第一个.清除多余的.
          .replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      },
      num4() {
        return this.inputNum4.replace(/[^\d.]/g, "") //清除‘数字’和‘.’以外的字符
          .replace(/^\./g, "")              //验证第一个字符是数字而不是.
          .replace(/\.{2,}/g, ".")          //只保留第一个.清除多余的.
          .replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      },
      integer() {
        return this.inputInteger.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
      integer2() {
        return this.inputInteger2.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
      videoInteger() {
        return this.inputVideoInteger.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
      //收费班的总价
      totalPrice2() {
        //如果课程单价不为空、课程次数不为空
        let condition = this.num3 !== '' && this.integer2 !== '';
        if (condition) {
          let starttime = this.startTime.getHours() + ':' + this.startTime.getMinutes();
          let endtime = this.endTime.getHours() + ':' + this.endTime.getMinutes();
          starttime = toMinutes(starttime);
          endtime = toMinutes(endtime);
          let price = Number(this.num3);
          let num = Number(this.integer2);
          let total = (endtime - starttime) / 60 * price * num;
          return total.toFixed(2);
        }
      },
      updateClassList () {
        return this.$store.state.updateClassList
      }
    },
    created() {
      //获取上课模式列表
      this.loadClassModeList();
      //获取课程列表
      this.loadClassList(1);
      //获取课件列表
      this.QueryCourseWares();

      //裁切图片上传的地址
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
    },
    watch: {
//      democlass(){
//        this.classperiod = '';
//      }
      // 用于监听createClass组件提交后的页面更新
      updateClassList: function () {
        this.loadClassList(1);
      }
    },
    components: {
      topNav,
      copyPop,
      messagePop,
      qrCodePop,
      VueCoreImageUpload,
      shareSchoolPage,
      aboveNav
    }
  }

</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .class
    position fixed
    left: 160px
    top: 91px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    z-index: 10
    .content-wrapper
      padding: 20px 0 20px
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin-left: 20px
        padding-bottom: 20px
        width: 1166px
        .class-head
          position: relative
          padding: 11px 10px 11px 15px
          width: 100%
          box-sizing: border-box
          background: #ffffff
          font-size: 0
          .demo
            position: absolute
            right: 10px
            bottom: 15px
            padding: 0 6px
            height: 30px
            line-height: 30px
            text-align: center
            font-size: 14px
            color: #fff
            border-radius: 4px
            background: #3399ff
            cursor: pointer
          .img
            float: left
            cursor pointer
          .class-info
            float: left
            margin-left: 20px
            .title
              line-height: 34px
              font-size: 16px
              color: #000000
              font-weight: bold
              cursor: pointer
              .preview
                position relative
                top: 7px
              .preview-text
                font-size: 14px
                color: #1296db
            .type
              line-height: 20px
              font-size: 12px
              color: #999999
              cursor: pointer
            .intro
              display: flex
              margin-top: 15px
              font-size: 12px
              color: #999999
              width: 970px
              .intro-left
                flex: 0 0 60px
                width: 60px
                line-height: 16px
              .intro-right
                height: 32px
                line-height: 16px
                overflow: hidden //必须http://www.cnblogs.com/zhunrong/p/6628828.html
                display: -webkit-box //必须
                -webkit-line-clamp: 2 //必须
                -webkit-box-orient: vertical
                .more
                  color: #3399ff
                  cursor: pointer
          .add, .modify
            position: absolute
            top: 10px
            height: 30px
            line-height: 30px
            text-align: center
            font-size: 14px
            color: #666666
            border: 1px solid #d7d7d7
            border-radius: 4px
            background: transparent
            box-sizing: border-box
            cursor: pointer
          .add
            /*right: 180px*/
            right: 95px
            width: 98px
          .modify
            /*right: 95px*/
            right: 10px
            width: 75px
          .share
            position: absolute
            top: 10px
            right: 100px
            height: 30px
            line-height: 30px
            width: 75px
            text-align: center
            font-size: 14px
            color: #ffffff
            border-radius: 4px
            background: #3399ff
            cursor: pointer
        .middle
          margin: 15px 0 20px
          height: 60px
          width: 100%
          background: #fff
          .new-class
            margin: 13px 25px 0 15px
            font-size: 14px
            color: #ffffff
            background: #3399ff
            padding: 0 10px
            height: 34px
            line-height: 34px
            border-radius: 4px

        .class-list
          font-size: 0
          .class-item
            display: inline-block
            margin: 0 26px 20px 0
            padding: 0 20px
            width: 570px
            height: 210px
            background: #fff
            box-sizing border-box
            &:hover
              box-shadow: 0 0 15px 2px #e4e4e4
            &:nth-child(2n)
              margin-right: 0
            .flex-wrapper
              display: flex
              height: 70px
              align-items center
              justify-content space-between
              .title-wrapper
                display: flex
                width: 450px
                align-items center
                .title
                  font-size: 20px
                  color: #000000
                  font-weight: bold
                  line-height: 70px
                  overflow hidden
                  text-overflow ellipsis
                  white-space nowrap
                .free-icon
                  flex: 0 0 40px
                  margin-left: 10px
                  font-size: 12px
                  color: #f76b6b
                  width: 40px
                  height: 16px
                  line-height: 16px
                  border: 1px solid #f76b6b
                  box-sizing border-box
                  border-radius 2px
                  text-align: center
              .enroll
                flex: 0 0 70px
                text-align right
                margin-right: 10px
                font-size: 12px
                color: #888
            .information-wrapper
              padding: 16px 10px 0
              box-sizing border-box
              background #f8f8f8
              cursor: pointer
              .flex-wrapper
                height: 18px
                display flex
                align-items center
                justify-content space-between
                .left
                  display flex
                  align-items center
                  .time
                    font-size: 12px
                    color: #888
                  .mode-icon
                    margin-left: 12px
                    font-size: 13px
                    color: #ffffff
                    height: 18px
                    line-height: 18px
                    width: 44px
                    text-align center
                    border-radius 2px
                  .before
                    background: #ff6666
                  .after
                    background: #3399ff
                  .on
                    background: #00cc66

                .right
                  font-size: 12px
                  color: #888
              .num
                padding: 12px 0 16px 0
                line-height: 18px
                font-size: 12px
                color: #888
            .btn-wrapper
              margin-top: 15px
              height: 30px
              overflow hidden
              .open
                float: left
                width: 95px
                height: 30px
                line-height: 30px
                text-align: center
                box-sizing: border-box
                font-size: 14px
                color: #666666
                border: 1px solid #d7d7d7
                border-radius 4px
                cursor pointer
              .on, .off
                float: left
                margin-left: 10px
                width: 80px
                height: 30px
                line-height: 30px
                text-align: center
                box-sizing: border-box
                font-size: 14px
                color: #704000
                border-radius 4px
                background #ffcc00
                cursor pointer
              .off
                background #ff6666
                color: #fff
              .copy, .share, .modify, .delete
                float: right
                margin-left: 5px
                width: 65px
                height: 30px
                line-height: 30px
                text-align: center
                box-sizing: border-box
                font-size: 12px
                color: #666
                border-radius 4px
                cursor pointer
                border: 1px solid #d7d7d7
              .copy:hover, .share:hover
                background #3399ff
                color: #ffffff
              .modify:hover
                background #00cc66
                color: #ffffff
              .delete:hover
                background #ff6666
                color: #ffffff
    .classpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .classpop
        margin: auto
        width: 1005px
        padding-left: 80px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          padding: 30px 0 50px
          line-height: 38px
          font-size: 28px
          color: #333333
          font-weight: bold
          .close
            float: right
            margin-right: 75px
            cursor pointer
        .row
          margin-bottom: 10px
          height: 35px
          position: relative
          .left
            vertical-align: top
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .type-select
            width: 105px
            font-size: 14px
            color: #000
            border: 1px solid #e4e4e4
            height: 35px
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
            &.disable
              background: #f5f7fa
              cursor: not-allowed
          .input-name
            width: 280px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .select-week
            display: inline-block
            width: 333px
            font-size: 14px
            color: #ccc
            border: 1px solid #e4e4e4
            height: 34px
            line-height: 34px
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
            &.disable
              background: #f5f7fa
              cursor: not-allowed
            .weektext
              float: left
              color: #000
          .week-select-wrapper
            display: inline-block
            position: absolute
            left: 85px
            top: 41px
            width: 333px
            height: 120px
            border: 1px solid #ccc
            z-index: 10
            background: #fff
            .week-item
              float: left
              margin: 10px 0 10px 10px
              width: 55px
              height: 22px
              line-height: 20px
              text-align: center
              font-size: 14px
              color: #cccccc
              border: 1px solid #cccccc
              border-radius: 4px
              box-sizing: border-box
              cursor: pointer
              &.now
                background: #3399ff
                line-height: 22px
                color: #fff
                border: none

            .week-btn-wrapper
              position: absolute
              bottom: 20px
              right: 10px
              .week-cancel, .week-confirm
                float: right
                font-size: 14px
                position: relative
                &:before
                  content: ''
                  position: absolute
                  top: -4px
                  left: -4px
                  right: -4px
                  bottom: -4px
              .week-cancel
                color: #ccc
                margin-right: 20px
              .week-confirm
                color: #3399ff
          .input-price
            padding-left: 6px
            width: 80px
            height: 35px
            font-size: 15px
            color: #000
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
            &.disable
              background: #f5f7fa
              cursor: not-allowed
          input[type='checkbox']
            display: none
          input[type='checkbox'] + span.checkbox
            display: inline-block
            width: 13px
            height: 13px
            background: #fff url('before.png') no-repeat center / 13px 13px
            position: relative
            top: 1px
            &.disable
              background #f5f7fa url('before.png') no-repeat center / 13px 13px
              cursor not-allowed
          input[type='checkbox']:checked + span.checkbox
            background: #fff url('after.png') no-repeat center / 13px 13px
            &.disable
              background #f5f7fa url('after.png') no-repeat center / 13px 13px
              cursor not-allowed
          .text
            display: inline-block
            height: 35px
            line-height: 35px
            font-size: 15px
            color: #888
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
            .upload-button-wrapper
              height: 30px
              margin-top: 10px
              padding-left: 10px
              .upload-button
                display: inline-block
                margin-right: 10px
                height: 30px
                line-height: 30px
                width: 90px
                text-align: center
                background: #f2f2f2
                color: #666
                font-size: 13px
                border: 1px solid #d7d7d7
                border-radius: 4px
                box-sizing border-box
                vertical-align: top
                cursor: pointer
              .hint
                display: inline-block
                padding: 0 10px
                height: 28px
                line-height: 28px
                text-align: center
                font-size: 12px
                color: #999999
                border-radius: 4px
                border: 1px solid #ffb76e
                background: #fff9e7

        .price
          display: inline-block
          margin: 0 0 10px 70px
          height: 70px
          line-height: 70px
          padding: 0 30px
          background url(./ticket.png) no-repeat
          background-size: 100% 70px
          .text
            display: inline-block
            font-size: 14px
            color: #704000
          .small
            width: 60px
          .big
            font-size: 32px
            font-weight: bold
          .delete
            margin-left: 55px
            color: #999999
            text-decoration line-through

        .split
          margin-bottom: 20px
          height: 10px
          width: 845px
          border-bottom: 2px dashed #d7d7d7
        .add-introduce
          width: 880px
          overflow hidden
          .left
            float: left
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .right
            float: left
            width: 795px
            .text-wrapper
              display: flex
              align-items center
              margin-bottom: 10px
              .text
                padding: 10px
                width: 760px
                height: 100px
                font-size: 15px
                color: #000
                box-sizing border-box
                border-radius 4px
                border: 1px solid #d7d7d7
                line-height: 20px
                resize: none
              .img
                margin-left: 10px
                cursor pointer

            .img-wrapper
              display: flex
              align-items center
              justify-content space-between
              margin-bottom: 10px
              .img-left
                width: 760px
                height: 100px
                position relative
                .input
                  position: absolute
                  left: 0
                  top: 0
                  height: 100px
                  width: 100px
                  padding: 0
                  margin: 0
                  opacity: 0

            .add
              margin-right: 10px
              height: 34px
              line-height: 34px
              width: 80px
              font-size: 14px
              color: #555555
              border: 1px solid #d7d7d7
              box-sizing border-box
              border-radius 4px

        .operate-btn-wrapper
          margin: 40px 0 30px 50px
          .btn
            margin-right: 65px
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            background #ccc
          .confirm
            background #3399ff

        .introduce-wrapper
          overflow hidden
          .left
            float: left
            width: 75px
            line-height: 35px
            font-size: 15px
            color: #888888
          .introduce
            float: left
            width: 760px
            margin-left: 10px
            padding-top: 5px
            img
              margin-bottom: 5px
            .text
              /*<pre>标签让<textarea>标签的内容原样输出http://www.cnblogs.com/mizzle/p/3874802.html*/
              margin-bottom: 5px
              padding: 0
              font-size: 15px
              text-align: left
              line-height: 24px
              color: #000
              width: 760px
              white-space: pre-wrap
              word-wrap: break-word
              word-break: break-all
    .warePop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .ware-content-wrapper
        margin: auto
        width: 720px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .ware-title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 40px
        .flex-wrapper
          margin: 25px 0 8px 0
          display: flex
          justify-content space-between
          .left
            font-size: 14px
            color: #000000
            line-height: 19px
          .right
            font-size: 14px
            color: #3399ff
            line-height: 19px
            cursor pointer
        .ware-wrapper
          width: 600px
          height: 450px
          padding: 20px
          border: 1px solid #e4e4e4
          box-sizing border-box
          overflow auto
          .classware
            padding: 10px 0
            border-bottom: 1px solid #e4e4e4
            .cover
              vertical-align top
            .classware-middle
              display: inline-block
              margin-left: 10px
              .title
                font-size: 14px
                color: #000000
                line-height: 22px
              .introduce
                margin-left: 22px
                width: 400px
                height: 26px
                font-size: 12px
                color: #999999
                line-height: 13px
                overflow hidden
            .del
              cursor pointer

        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff

    .videopop-wrapper
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .videopop
        margin: auto
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          margin-bottom: 45px
          line-height: 40px
          font-size: 24px
          color: #000
          font-weight: bold
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            font-size: 15px
            color: #888
          .input-price
            padding-left: 6px
            width: 70px
            height: 35px
            font-size: 15px
            color: #000
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .type-select
            width: 400px
            font-size: 15px
            border: 1px solid #e4e4e4
            height: 35px
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
            &.default
              color: #ccc
            .select-hint
              color: #ccc
            .select-item
              color: #000
          .text
            display: inline-block
            height: 35px
            line-height: 35px
            font-size: 15px
            color: #000
          .hint
            margin-left: 4px
            display: inline-block
            padding: 0 6px
            height: 28px
            line-height: 28px
            text-align: center
            font-size: 12px
            color: #999999
            border: 1px solid #ffb76e
            background: #fff9e7
        .play
          height: 35px
          line-height: 35px
          padding: 0 10px
          border-radius 4px
          background #ff6666
          font-size: 16px
          color: #fff
          img
            position relative
            top: 4px
        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff
    .videopreview-wrapper
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .videopreview
        margin: auto
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position: relative
        .video-close
          position absolute
          right: 20px
          top: 30px
          cursor: pointer
        .title
          margin-bottom: 45px
          line-height: 40px
          font-size: 24px
          color: #000
          font-weight: bold
        .img-wrapper
          width: 300px
          height: 200px
          margin: 35px 20px 10px
          position relative
          .video-mask
            position absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            background: rgba(0, 0, 0, 0.3)
            display flex
            justify-content center
            align-items center
            .video-preview
              cursor: pointer
        .re-video
          height: 30px
          line-height: 30px
          font-size: 14px
          color: #666666
          .color
            color: #3399ff
            cursor: pointer
        .upload-btn
          margin: 40px auto 0
          display block
          width: 180px
          height: 40px
          line-height: 40px
          background: #3399ff
          border-radius 4px
          font-size: 16px
          color: #ffffff
          text-align: center
          cursor: pointer
    .coverpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .coverpop
        margin: auto
        padding-bottom: 16px
        width: 752px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position: relative
        .close-btn
          position: absolute
          top: 0
          right: 0
          display: block
          width: 34px
          height: 34px

        .title
          height: 34px
          line-height: 34px
          padding-left: 22px
          font-size: 14px
          color: #333333
          background: #f3f3f3
        .cover-wrapper
          padding: 22px 22px 52px
          background: #fff
          .coverimg-wrapper
            display: inline-block
            margin: 0 16px 16px 0
            width: 165px
            height: 110px
            position: relative
            &:nth-child(4n)
              margin-right: 0
            .circle
              position: absolute
              top: 8px
              left: 8px
              display: inline-block
              width: 12px
              height: 12px
              border-radius: 6px
              background: rgba(255, 255, 255, 0.5)
              .in-circle
                position: absolute
                top: 2px
                left: 2px
                display: inline-block
                width: 8px
                height: 8px
                border-radius: 4px
                background: #3399ff
        .btn-wrapper
          padding: 8px 22px
          background: #f3f3f3
          height: 34px
          .confirm-btn
            height: 34px
            line-height: 34px
            width: 120px
            text-align: center
            border-radius: 4px
            background: #3399ff
            font-size: 14px
            color: #fff
          .upload-button
            display: inline-block
            margin-left: 20px
            height: 34px
            line-height: 34px
            width: 120px
            text-align: center
            background: #fff
            color: #666
            font-size: 14px
            border: 1px solid #666
            border-radius: 4px
            box-sizing border-box
            vertical-align: top
            cursor: pointer
          .hint
            margin-left: 10px
            display: inline-block
            font-size: 14px
            height: 34px
            line-height: 34px
            color: #666
</style>



// WEBPACK FOOTER //
// src/page/class/Class.vue